import { BaseElement } from './base-element';
import { ElementType } from './element-type';
import { Option } from './option';

export class Input extends BaseElement {
  label: string | null = null;
  placeholder: string | null = null;
  value: any | null = null;
  amount: number | null = null;
  name: string;
  required: boolean = false;
  type: string = 'text';
  disabled: boolean = false;
  checked: any = false;
  //radioGroup: string = '';
  options: Option[] = [];
  inline: boolean = true;
  rows: number = 3;
  decimals: number = 0;
  accept: string = '';
  multiple: boolean = false;
  maxSize: number | null = null;
  popover: string = '';
  maxLength: number | null = null;
  submitScannerOnEnter: boolean = true;

  constructor(name: string, type: string = 'text', label: string | null = null, placeholder: string | null = null) {
    super();
    this.elementType = ElementType.input;
    this.name = name;
    this.type = type;
    this.label = label;
    this.placeholder = placeholder;
  }
}
